import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import HeaderFive from '../../components/Header/HeaderFive';
import Footer from '../../components/Footer';
import FooterThree from '../../components/Footer/FooterThree';
import ComplainMain from './ComplainMain';

const Complain = () => {
  return (
    <>
      <HeaderFive />

      <ComplainMain />

      <FooterThree />
    </>
  );
};

export default Complain;
